module.exports = __webpack_public_path__ + "static/media/f1.51dca98c.jpg";